export class NumbersRange {
  max: number;
  min: number;
  readonly optionalMin: number | undefined | null;
  readonly optionalMax: number | undefined | null;
  constructor(elements: (number | null)[]) {
    const [min, max] = getMaxAndMin(elements.map(e => (e == null ? 0 : e)));
    this.min = min;
    this.max = max;
    this.optionalMin = elements.find(e => e === min);
    this.optionalMax = elements.find(e => e === max);
  }

  static fromMinMax(min: number, max: number) {
    return new NumbersRange([min, max]);
  }

  static excludingNils(elements: (number | null)[]) {
    return new NumbersRange(
      elements.filter(element => element != null) as number[]
    );
  }

  withinRange(value: number) {
    return value >= this.min && value <= this.max;
  }
}

export const getMaxAndMin = <T extends number>(
  elements: T[]
): [number, number] => [
  Math.min.apply(null, elements),
  Math.max.apply(null, elements)
];
